import { Link } from "@/components/Link";
import type { OrgDetail } from "../../types";
import { useAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TabLayout } from "../TabLayout";

export function SendoutLabTestsTable({ org }: { org: OrgDetail }) {
  const testSpecs = org?.referenceTestSpecs || [];

  const { options } = useAdminGridOptions(
    testSpecs,
    [
      {
        field: "name",
        headerName: "Name",
        flex: 1,
        minWidth: 200,
        cellRenderer: (params) => (
          <Link to="/admin/tests/$id/edit" params={{ id: params.id }}>
            {params.name}
          </Link>
        ),
        cellRendererParams: (params) => ({
          id: params.data.id,
          name: params.data.name,
        }),
      },
      {
        field: "code",
        headerName: "Code",
        width: 140,
        maxWidth: 200,
      },
    ],
    {
      sideBar: undefined,
    },
  );

  return (
    <TabLayout description="The following test specs use this lab as a reference lab">
      <AdminGrid {...options} />
    </TabLayout>
  );
}
